import {type ErrorComponentProps} from '@tanstack/react-router'

import {logError} from '@/utils/logger'

import ErrorComponent from './ErrorComponent'

export default memo<ErrorComponentProps>(function RouterErrorComponent({error, info, reset}) {
  const router = useRouter()
  const queryErrorResetBoundary = useQueryErrorResetBoundary()

  useEffect(() => {
    // Reset the query error boundary
    queryErrorResetBoundary.reset()
  }, [queryErrorResetBoundary])

  logError(error, info as Record<'componentStack', string>)

  return (
    <ErrorComponent
      reset={useCallback(() => {
        // Reset the router error boundary
        reset()
        // Invalidate the route to reload the loader
        void router.invalidate()
      }, [router, reset])}
    />
  )
})
